<template>
  <div class="appeal">
    <el-tabs v-model="currentTab">
      <el-tab-pane
        v-for="tab in tabs"
        :key="tab.name"
        :label="tab.label"
        :name="tab.name"
      >
        <div class="appeal-search-container">
          <el-row :gutter="10">
            <el-col :span="5">
              <el-select v-model="searchQuery.appealType" clearable size="small" placeholder="内容类别">
                <el-option
                  v-for="option in AppealTypes"
                  :key="option.label"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
            </el-col>
            <el-col :span="5">
              <el-input v-model.trim="searchQuery.nickname" @keyup.enter.native="fetchAppeals" size="small" placeholder="申诉者Full Name或Birth Name" />
            </el-col>
            <el-col :span="6">
              <el-date-picker
                v-model="searchQuery.dateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                size="small"
              />
            </el-col>
            <el-col :span="8" class="appeal-search-actions">
              <el-button size="small" @click="onClearSearchQueryClicked">清除条件</el-button>
              <el-button size="small" @click="onSearchClicked" class="appeal-search-submit">立即筛选</el-button>
            </el-col>
          </el-row>
        </div>
        <basic-container>
          <avue-crud
            :data="tableRecords"
            :page.sync="page"
            :table-loading="isLoading"
            :option="tableOptions"
            @current-change="onCurrentPageChanged"
            @size-change="onPageSizeChanged"
          >
            <template slot="appealBy" slot-scope="scope">
              <router-link :to="scope.row.appealBy.memberType === 1 ? { name: '官方号详情', params: { id: scope.row.appealBy.id } } : { name: '用户详情', params: { id: scope.row.appealBy.id } }" class="appeal-link">
                {{ scope.row.appealBy.name }}
              </router-link>
            </template>
            <template slot="appealByRealname" slot-scope="scope">
              <router-link :to="{ name: '用户详情', params: { id: scope.row.appealBy.memberType === 1 ? scope.row.appealBy.relatedPersonalMemberId : scope.row.appealBy.id} }" class="appeal-link">
                {{ scope.row.appealBy.memberType === 1 ? scope.row.appealBy.relatedPersonalRealname : scope.row.appealBy.realname}}
              </router-link>
            </template>
            <template slot="appealType" slot-scope="scope">
              {{ getAppealTypeDisplayName(scope.row.appealType) }}
            </template>
            <template slot="appealAttachments" slot-scope="scope">
              <span
                v-if="scope.row.appealAttachments && scope.row.appealAttachments.length > 0"
                @click="onAttachmentLinkClicked(scope.row.appealAttachments)"
                class="appeal-link"
              >
                附件详情
              </span>
            </template>
            <template slot="content" slot-scope="scope">
              <router-link :to="getContentLink(scope.row)" class="appeal-link">
                {{ scope.row.content | formatEmptyData }}
              </router-link>
            </template>
            <template slot="status" slot-scope="scope">
              {{ getStatusDisplayName(scope.row) }}
            </template>
            <template v-if="currentTab === 'notAudited'" slot="menu" slot-scope="scope">
              <el-button @click="onRejectClicked(scope.row)" type="text" size="mini">拒绝</el-button>
              <el-button @click="onAcceptClicked(scope.row)" type="text" size="mini">上架内容</el-button>
              <el-button @click="onPendingClicked(scope.row)" type="text" size="mini">待处理</el-button>
            </template>
          </avue-crud>
        </basic-container>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="附件详情" :visible.sync="shouldShowAttachmentsDialog" width="40%" class="appeal-dialog-attachments">
      <div v-for="attachment in currentAttachments" :key="attachment.id">
        <img v-if="attachment.thumbnailUrl" :src="attachment.thumbnailUrl" class="appeal-dialog-attachments-img">
      </div>
    </el-dialog>
    <el-dialog title="上架" :visible.sync="acceptDialog.shouldShowDialog" width="40%">
      <div class="appeal-dialog-accept-title">上架原因</div>
      <el-input class="appeal-dialog-accept-reason" v-model.trim="acceptDialog.reason" />
      <el-checkbox v-model.trim="acceptDialog.isSendWxMessage" class="appeal-dialog-accept-checkbox">是否发送消息通知</el-checkbox>
      <el-input v-if="acceptDialog.isSendWxMessage" :rows="3" class="appeal-dialog-accept-message" v-model.trim="acceptDialog.wxMessage" type="textarea" placeholder="消息" />
      <div slot="footer">
        <el-button @click="onCancelAcceptDialogClicked">取消</el-button>
        <el-button @click="onConfirmAcceptDialogClicked" type="primary">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog title="下架" :visible.sync="rejectDialog.shouldShowDialog" width="40%">
      <div class="appeal-dialog-reject-title">下架原因</div>
      <el-input class="appeal-dialog-reject-reason" v-model.trim="rejectDialog.reason" />
      <el-checkbox v-model.trim="rejectDialog.isSendWxMessage" class="appeal-dialog-reject-checkbox">是否发送消息通知</el-checkbox>
      <el-input v-if="rejectDialog.isSendWxMessage" :rows="3" class="appeal-dialog-reject-message" v-model.trim="rejectDialog.wxMessage" type="textarea" placeholder="消息" />
      <div slot="footer">
        <el-button @click="onCancelRejectDialogClicked">取消</el-button>
        <el-button @click="onConfirmRejectDialogClicked" type="primary">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog title="待处理" :visible.sync="pendingDialog.shouldShowDialog" width="40%">
      <div class="appeal-dialog-pending-title">待处理原因</div>
      <el-input class="appeal-dialog-pending-reason" v-model.trim="pendingDialog.reason" />
      <el-checkbox v-model.trim="pendingDialog.isSendWxMessage" class="appeal-dialog-pending-checkbox">是否发送消息通知</el-checkbox>
      <el-input v-if="pendingDialog.isSendWxMessage" :rows="3" class="appeal-dialog-pending-message" v-model.trim="pendingDialog.wxMessage" type="textarea" placeholder="消息" />
      <div slot="footer">
        <el-button @click="onCancelPendingDialogClicked">取消</el-button>
        <el-button @click="onConfirmPendingDialogClicked" type="primary">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import { tableOptions, AppealTypes } from '@/const/crud/appeal'
import { fetchAppeals, acceptAppeal, rejectAppeal, pendingAppeal } from '@/api/appeal'

const TAB_STATUS_MAPPING = {
  notAudited: '0',
  audited: '1,2'
};

export default {
  data() {
    return {
      currentTab: 'notAudited',
      searchQuery: {
        appealType: undefined,
        nickname: undefined,
        dateRange: [],
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      isLoading: false,
      tableData: undefined,
      currentAttachments: [],
      shouldShowAttachmentsDialog: false,
      acceptDialog: {
        id: undefined,
        shouldShowDialog: false,
        reason: '',
        isSendWxMessage: false,
        wxMessage: ''
      },
      rejectDialog: {
        id: undefined,
        shouldShowDialog: false,
        reason: '',
        isSendWxMessage: false,
        wxMessage: ''
      },
      pendingDialog: {
        id: undefined,
        shouldShowDialog: false,
        reason: '',
        isSendWxMessage: false,
        wxMessage: '',
      }
    };
  },
  computed: {
    tabs() {
      return [{
        label: '待审核列表',
        name: 'notAudited',
      }, {
        label: '已审核列表',
        name: 'audited',
      }];
    },
    AppealTypes() {
      return AppealTypes;
    },
    listQuery() {
      const { nickname, appealType, dateRange } = this.searchQuery;
      const [appealStartTime, appealEndTime] = dateRange || [];
      const { currentPage: current, pageSize: size } = this.page;
      const status = TAB_STATUS_MAPPING[this.currentTab];
      return { nickname, appealType, appealStartTime, appealEndTime: this.getAppealEndTime(appealEndTime), status, current, size };
    },
    tableOptions() {
      if (this.currentTab === 'notAudited') return tableOptions;
      return { ...tableOptions, menu: false }
    },
    tableRecords() {
      if (!this.tableData) return [];
      return this.tableData.records;
    },
  },
  watch: {
    currentTab() {
      this.resetSearchQuery();
      this.tableData = undefined;
      this.fetchAppeals();
    },
  },
  created() {
    this.fetchAppeals();
  },
  methods: {
    resetSearchQuery() {
      this.searchQuery = { dateRange: [] };
    },
    onClearSearchQueryClicked() {
      this.resetSearchQuery();
      this.onSearchClicked();
    },
    onSearchClicked() {
      this.page.currentPage = 1;
      this.fetchAppeals();
    },
    fetchAppeals() {
      this.isLoading = true;
      fetchAppeals(this.listQuery)
        .then(({ data: { data } }) => {
          this.tableData = data;
          this.page.total = data.total;
          this.isLoading = false;
        })
        .catch(() => { this.isLoading = false; });
    },
    onPageSizeChanged() {
      this.page.currentPage = 1;
      this.fetchAppeals();
    },
    onCurrentPageChanged(params) {
      this.page.currentPage = params
      this.fetchAppeals();
    },
    getAppealTypeDisplayName(appealType) {
      switch (appealType) {
        case 0:
          return '内容';
        case 1:
          return '评论';
        default:
          return '';
      }
    },
    onAttachmentLinkClicked(attachments) {
      this.currentAttachments = attachments;
      this.shouldShowAttachmentsDialog = true;
    },
    getContentLink({ appealType, targetId }) {
      switch (appealType) {
        case 0:
          return { name: '内容详情', params: { id: targetId } };
        case 1:
          return { name: '评论详情', params: { id: targetId } };
        default:
          break;
      }
    },
    getStatusDisplayName({ status }) {
      switch (status) {
        case 0:
          return '未处理';
        case 1:
          return '已上架';
        case 2:
          return '未通过';
        default:
          return '';
      }
    },
    onRejectClicked({ id }) {
      this.rejectDialog = {
        id,
        shouldShowDialog: true,
        reason: '',
        isSendWxMessage: false,
        wxMessage: '你的申诉未通过，请重新审核发布内容'
      }
    },
    onAcceptClicked({ id }) {
      this.acceptDialog = {
        id,
        shouldShowDialog: true,
        reason: '',
        isSendWxMessage: false,
        wxMessage: '你的申诉已通过，内容已上架'
      }
    },
    onPendingClicked({ id }) {
      this.pendingDialog = {
        id,
        shouldShowDialog: true,
        reason: '',
        isSendWxMessage: false,
        wxMessage: ''
      }
    },
    onCancelAcceptDialogClicked() {
      this.acceptDialog.shouldShowDialog = false;
    },
    onCancelRejectDialogClicked() {
      this.rejectDialog.shouldShowDialog = false;
    },
    onCancelPendingDialogClicked() {
      this.pendingDialog.shouldShowDialog = false;
    },
    onConfirmAcceptDialogClicked() {
      if (!this.acceptDialog.reason) return this.$message({
        showClose: true,
        message: '上架原因不能为空',
        type: 'error'
      });
      if (this.acceptDialog.isSendWxMessage &&
          !this.acceptDialog.wxMessage) return this.$message({
        showClose: true,
        message: '通知内容不能为空',
        type: 'error'
      });
      const { id, isSendWxMessage, reason, wxMessage } = this.acceptDialog;
      acceptAppeal({ id, isSendWxMessage, reason, wxMessage })
        .then(() => {
          this.onCancelAcceptDialogClicked();
          this.fetchAppeals();
        });
    },
    onConfirmRejectDialogClicked() {
      if (!this.rejectDialog.reason) return this.$message({
        showClose: true,
        message: '下架原因不能为空',
        type: 'error'
      });
      if (this.rejectDialog.isSendWxMessage &&
        !this.rejectDialog.wxMessage) return this.$message({
        showClose: true,
        message: '通知内容不能为空',
        type: 'error'
      });
      const { id, isSendWxMessage, reason, wxMessage } = this.rejectDialog;
      rejectAppeal({ id, isSendWxMessage, reason, wxMessage })
        .then(() => {
          this.onCancelRejectDialogClicked();
          this.fetchAppeals();
        });
    },
    onConfirmPendingDialogClicked() {
      if (!this.pendingDialog.reason) return this.$message({
        showClose: true,
        message: '待处理原因不能为空',
        type: 'error'
      });
      if (this.pendingDialog.isSendWxMessage &&
        !this.pendingDialog.wxMessage) return this.$message({
        showClose: true,
        message: '通知内容不能为空',
        type: 'error'
      });
      const { id, isSendWxMessage, reason, wxMessage } = this.pendingDialog;
      pendingAppeal({ id, isSendWxMessage, reason, wxMessage })
        .then(() => {
          this.onCancelPendingDialogClicked();
          this.fetchAppeals();
        });
    },
    getAppealEndTime(dateTime) {
      if (!dateTime) return;
      return moment(dateTime).add('day', 1).format('YYYY-MM-DD');
    }
  },
};
</script>

<style lang="scss" scoped>
$page-padding-left: 22px;
$search-container-padding: 20px 10px 0;
$search-submit-color: #5383f3;

.appeal {
  background-color: #fff;
  padding: $page-padding-left;
  &-search {
    &-container {
      padding: $search-container-padding;
    }
    &-actions {
      display: flex;
      justify-content: flex-end;
    }
    &-submit {
      border-color: $search-submit-color;
      color: $search-submit-color;
    }
  }
  &-link {
    color: #409EFF;
    cursor: pointer;
    font-weight: 500;
  }
  &-dialog {
    &-accept,
    &-reject,
    &-pending {
      &-title + &-reason {
        margin-top: 10px;
      }
      &-checkbox {
        align-items: center;
        display: flex;
        height: 40px;
      }
    }
  }
  &-dialog-attachments-img {
    max-width: 500px;
  }
}
</style>
